import { useEffect } from 'react'
import { CookiesProvider } from 'react-cookie'
import { ToastContainer } from 'react-toastify'
import { nb } from 'date-fns/locale'
import CssBaseline from '@mui/material/CssBaseline'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import * as Sentry from '@sentry/react'
import { BrowserTracing } from '@sentry/tracing'
import './components/Common/Styles/CustomMuiTableStyle.css'
import ErrorPage from './components/Common/ErrorPage'
import { ThemeContextProvider } from './components/Context/ThemeContextProvider'
import { history } from './helpers/history'
import { MainRouter } from './MainRouter'

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: 'https://7783c48d3f5141b283dc4bcaa5e92563@o4504832929103872.ingest.sentry.io/4504832930676736',
    debug: false,
    environment: process.env.NODE_ENV,
    replaysSessionSampleRate: process.env.NODE_ENV === 'production' ? 1.0 : 0.1,
    integrations: [
      new BrowserTracing({
        routingInstrumentation: Sentry.reactRouterV5Instrumentation(history),
      }),
      new Sentry.Replay(),
    ],
    tracesSampleRate: 1.0,
    ignoreErrors: ['ChunkLoadError', 'TypeError', 'React ErrorBoundary Error'],
  })
}

export const App = () => {
  useEffect(() => {
    history.listen(location => {
      if ('FreshworksWidget' in window) {
        window.FreshworksWidget('prefill', 'ticketForm', {
          custom_fields: {
            cf_url: location.pathname,
          },
        })
      }
    })
  }, [history])

  return (
    <ThemeContextProvider>
      <Sentry.ErrorBoundary fallback={e => <ErrorPage error={e.error} />}>
        <CssBaseline />
        <CookiesProvider>
          <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={nb}>
            <MainRouter />
            <ToastContainer
              position="top-right"
              autoClose={5000}
              hideProgressBar={false}
              newestOnTop={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme="light"
              className={'toast-vessel'}
            />
          </LocalizationProvider>
        </CookiesProvider>
      </Sentry.ErrorBoundary>
    </ThemeContextProvider>
  )
}
